import { Badge, Flex, Tooltip } from '@customerio/pluma-components/react';
import type { IntegrationLabel } from '../card-model';

const VISIBLE_LABELS_LIMIT = 3;
const VISIBLE_LIMIT_INDEX = VISIBLE_LABELS_LIMIT - 1;

type CardLabelsProps = {
  labels: IntegrationLabel[];
};

/**
 * The card's label row. Up to three labels show inline; beyond that the first
 * two show and the rest collapse into a `+N` label with a tooltip listing them.
 */
export function CardLabels({ labels }: CardLabelsProps) {
  const hasHiddenLabels = labels.length > VISIBLE_LABELS_LIMIT;
  const visibleLabels = hasHiddenLabels ? labels.slice(0, VISIBLE_LIMIT_INDEX) : labels;
  const hiddenLabelsCount = labels.length - VISIBLE_LIMIT_INDEX;
  const hiddenLabelsTooltip = labels
    .slice(VISIBLE_LIMIT_INDEX)
    .map((label) => label.text)
    .join(', ');

  return (
    <Flex flexGrow="0" gap="125" wrap={false}>
      {visibleLabels.map((label) => (
        <Badge key={label.text} data-test-integrations-card-label={label.text} color={label.color ?? 'grey'}>
          {label.text}
        </Badge>
      ))}
      {hasHiddenLabels ? (
        <Tooltip content={hiddenLabelsTooltip}>
          <Badge color="grey">+{hiddenLabelsCount}</Badge>
        </Tooltip>
      ) : null}
    </Flex>
  );
}
